module.exports = __webpack_public_path__ + "static/media/logo.45916f76.png";